import React from 'react';
import { Typography } from '@mui/material';

import {
  BuildingAreasList,
  CloseButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  SubmitButton,
} from 'components';
import { IBuildingArea } from '../../models';

interface BuildingAreaListDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
  areas: IBuildingArea[];
  setAreas: (areas: IBuildingArea[]) => void;
  buildingId: number | undefined;
  title?: string;
}

export const BuildingAreasDialog: React.FC<BuildingAreaListDialogProps> = ({
  visible = false,
  setVisible = () => {},
  title = 'Manage Building Areas',
  areas,
  setAreas,
  buildingId,
}: BuildingAreaListDialogProps) => {
  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  return (
    <Dialog open={visible} onClose={onClose}>
      <DialogTitle>
        <Typography variant="h5" component="span">
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <BuildingAreasList areas={areas} setAreas={setAreas} buildingId={buildingId} />
      </DialogContent>

      <DialogActions>
        <SubmitButton label="Done" onClick={() => setVisible(false)} />
      </DialogActions>

      <CloseButton onClick={() => onClose(null, 'anyway')} />
    </Dialog>
  );
};
